import React from "react";
import styled, { keyframes, css, RuleSet } from "styled-components";
import ProgressBar from "react-bootstrap/ProgressBar";
import { compassLightGreen } from "../../../styles";

// Keyframes for sliding gradient animation
const slide = keyframes`
  0% { background-position: 0% 50%; }
  100% { background-position: 100% 50%; }
`;

const StyledProgressBar = styled(ProgressBar)<{ $isLoading: boolean }>`
  width: 100%;
  height: 10px;
  background: linear-gradient(
    270deg,
    rgba(32, 226, 144, 1) 0%,
    rgba(32, 226, 144, 1) 10%,
    rgba(32, 226, 144, 1) 20%,
    rgba(32, 226, 144, 1) 30%,
    rgba(32, 226, 144, 1) 40%,
    rgba(236, 236, 236, 1) 50%,
    rgba(236, 236, 236, 1) 60%,
    rgba(236, 236, 236, 1) 70%,
    rgba(236, 236, 236, 1) 80%,
    rgba(236, 236, 236, 1) 90%,
    rgba(32, 226, 144, 1) 100%
  );
  background-size: 200% 200%;
  ${({ $isLoading }): string =>
    $isLoading ? "" : `background: ${compassLightGreen}`};
  animation: ${({ $isLoading }): "none" | RuleSet<object> =>
    $isLoading
      ? css`
          ${slide} 1.7s linear infinite
        `
      : "none"};
  transform: rotate(180deg);
  border-radius: 5px;
`;

export interface GradientProgressBarProps {
  /** Whether the progress bar is in loading/animating state */
  isLoading: boolean;
  /** Custom class name */
  className?: string;
}

/**
 * Animated gradient progress bar for file uploads.
 * Shows a sliding gradient animation when loading, solid green when complete.
 */
export const GradientProgressBar: React.FC<GradientProgressBarProps> = ({
  isLoading,
  className,
}) => {
  return (
    <StyledProgressBar now={0} $isLoading={isLoading} className={className} />
  );
};
